const validators = {
  names: {
    message: 'Please enter a name in the highlighted rows!',
  },
  presence: {
    func: (string = '') => !!string.trim(),
    message: 'A value is required',
  },
  email: {
    func: (string = '') => {
      const pattern = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

      return pattern.test(string.trim());
    },
    message: 'Make sure this email is correct!',
  },
  password: {
    func: (string = '') => {
      const pattern = /[\d\w!]{6,18}/;

      return pattern.test(string.trim());
    },
    message: 'Password is too short (minimum is 6 characters).',
  },
  phone: {
    func: (number = '') => {
      const internationalPattern = /^\+.*$/;
      const usPattern = /^(?:(?:(?!0|1)\d{3}-|\((?!0|1)\d{3}\)\s?)\d{3}-\d{4}|(?!0|1)\d{10})$/;
      if (internationalPattern.test(number)) {
        return internationalPattern.test(number);
      }
      return usPattern.test(number);
    },
    message: 'Make sure this phone number is correct!',
  },
  zip: {
    func: (zipCode = '', isUS = true) => {
      if (isUS) {
        const pattern = /^(\d{5}|\d{5}-\d{4})$/;
        return pattern.test(zipCode);
      }
      return true;
    },
    message: 'Make sure this zip code is correct!',
  },
};

export default validators;
